
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.41 12L20 5.42A1 1 0 0018.6 4L12 10.59 5.41 4A1 1 0 004 5.41L10.6 12 4 18.62A1 1 0 004 20a1 1 0 001.41 0L12 13.45 18.6 20a1 1 0 001.4 0 1 1 0 000-1.38z"}})])
          )
        }
      }
    